import { ExplorerLogo } from '@bcba/brand';
import { Authenticator } from '../config/auth/auth';
import MainLayout from '../components/MainLayout/MainLayout';
import { useTranslation } from '@bcba/react-hooks';
import { UserProvider } from '../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { paths } from './paths';

export const PrivatePageWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { t } = useTranslation();
  const navigation = useNavigate();
  const formFields = {
    signIn: {
      username: {
        label: t('common.CUIT/CUIL'),
        placeholder: t('amplify.fiscalId.placeholder'),
      },
      password: {
        label: t('common.password'),
        placeholder: t('amplify.password.placeholder'),
      },
    },
    forgotPassword: {
      username: {
        label: t('common.CUIT/CUIL'),
        placeholder: t('amplify.fiscalId.placeholder'),
      },
    },
  };

  const translations = {
    'username is required to signIn': t('amplify.fiscalIdRequiredToSignIn'),
    'username is required to resetPassword': t(
      'amplify.fiscalIdRequiredToResetPassword',
    ),
  };

  return (
    <Authenticator
      translations={translations}
      defaultLogo={<ExplorerLogo size="md" />}
      formFields={formFields}
      hideSignUp
      onClickSignUp={() => navigation(paths.signup)}
    >
      <UserProvider>
        <MainLayout>{children}</MainLayout>
      </UserProvider>
    </Authenticator>
  );
};
